import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Account } from '../../../models/account/account';
import { StorageService } from '../../../core/storage/storageService';
import { Merchant } from '../../../models/merchant/merchant';
import { AccessManager } from '../../ui/access-manager/access-manager';
import { Subscription } from '../../../../../../../node_modules/rxjs/dist/types';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { MerchantService } from '../../../models/merchant/merchantService';
import { UIHelpers } from '../../../core/ui-helpers';
import { MatDialog } from '@angular/material/dialog';
import { ContactDialogComponent } from '../../ui/dialogs/contact-dialog/contact-dialog.component';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';
import { ProcessorDetail, ProcessorDetails } from '../../../core/constants';

@Component({
  selector: 'app-merchant-header',
  templateUrl: './merchant-header.component.html',
  standalone: false,
})
export class MerchantHeaderComponent {
  readonly ProcessorDetails = ProcessorDetails;
  readonly UIHelpers = UIHelpers;

  currentAccount: Account | undefined;
  currentMerchant: Merchant | undefined;
  showBusinessInfo: boolean = true;
  showMerchantNav: boolean = false;
  selectedButton: string | undefined;
  mids: ListItem[] = [];

  //allowViewTerminal: boolean = false;
  //allowViewTransactions: boolean = false;
  //allowViewCustomers: boolean = false;

  public merchantObserver: Subscription | undefined;
  public showMasterAccountLink: boolean = false;

  constructor(
    public router: Router,
    private merchantService: MerchantService,
    private storageService: StorageService,
    private accessManager: AccessManager,
    private uiHelpers: UIHelpers,
    private uiErrorHandler: UIErrorHandler,
    public contactDialog: MatDialog,
  ) {
    try {
      this.currentAccount = storageService.getSelectedAccount();
    } catch {}

    try {
      this.currentMerchant = storageService.getSelectedLocation();
    } catch {}
  }

  ngOnInit() {
    this.accessManager
      .getUserAccess([
        AccessManager.AUTH_SELECT_BUSINESSES,
        AccessManager.AUTH_SELECT_ALL_BUSINESSES,
        AccessManager.AUTH_MERCHANT_NAV,
        //AccessManager.AUTH_ACCESS_TERMINAL,
        //AccessManager.AUTH_SELECT_MERCHANT_TRANSACTIONS,
        //AccessManager.AUTH_SELECT_CUSTOMERS
      ])
      .then((access) => {
        this.showBusinessInfo =
          access[AccessManager.AUTH_SELECT_BUSINESSES] ||
          this.storageService.getNumberOfMyBusinesses() > 1;
        this.showMerchantNav = access[AccessManager.AUTH_MERCHANT_NAV];
        //this.allowViewTerminal = access[AccessManager.AUTH_ACCESS_TERMINAL];
        //this.allowViewTransactions = access[AccessManager.AUTH_SELECT_MERCHANT_TRANSACTIONS];
        //this.allowViewCustomers = access[AccessManager.AUTH_SELECT_CUSTOMERS];

        if (this.currentAccount) {
          //   // TODO: figure out why this method needs to be static instead of instance...
          this.mids = Account.GetLocationsAsList(this.currentAccount);
        }

        if (
          this.storageService.getNumberOfMyBusinesses() > 1 ||
          this.storageService.getCurrentUser()?.isSwipesumInternalUser()
        ) {
          this.showMasterAccountLink = true;
        }
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });

    this.merchantObserver =
      this.storageService.selectedLocationObservable.subscribe((data) => {
        if (data) {
          this.currentMerchant = data;
          // console.log(Object.getPrototypeOf(nm)); // Check if the method is on the prototype
          // console.log(typeof nm.getContactByType); // Should be 'function'
        }
      });
  }

  ngOnDestroy() {
    this.merchantObserver?.unsubscribe();
  }

  btnViewAccount_click() {
    this.router.navigateByUrl(
      '/business?id=' + this.currentMerchant?.accountId,
    );
  }

  handleSelectedMerchantChanged(merchantId: string) {
    this.merchantService
      .getMerchantById(merchantId)
      .then((merch) => {
        this.uiHelpers.selectMerchant(new Merchant(merch));
        this.router.navigateByUrl('merchant/account');
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  btnSuccess_click() {}

  btnSales_click() {
    let ref = this.contactDialog.open(ContactDialogComponent, {
      width: '500px',
      disableClose: false,
      data: {
        leadId: '',
        readonly: true,
      },
    });

    this.router.events.subscribe(() => {
      ref.close();
    });

    ref.afterClosed().subscribe((refresh) => {
      if (refresh) {
        // reload history
      }
    });
  }

  btnContact_click() {
    let ref = this.contactDialog.open(ContactDialogComponent, {
      width: '500px',
      disableClose: false,
      data: {
        contact: this.currentMerchant?.primaryContact,
        readonly: true,
      },
    });

    this.router.events.subscribe(() => {
      ref.close();
    });

    ref.afterClosed().subscribe((refresh) => {
      if (refresh) {
        // reload history
      }
    });
  }

  getProcessorDetails(processor: string | string[]): ProcessorDetail | undefined {
    const name = Array.isArray(processor) ? processor[0] : processor;
    return this.ProcessorDetails[name as keyof typeof ProcessorDetails];
  }
}
